const state = {
  tags: [
      { id:1,name: 'Action', icon: 'tags/runner.svg' },
      { id:2,name: 'Adventure', icon: 'tags/cardinal-points.svg' },
      { id:3,name: 'Guess', icon: 'tags/question.svg' },
      { id:4,name: 'Maximum score', icon: 'tags/scoreboard.svg' },
      { id:5,name: 'Kids', icon: 'tags/baby.svg' },
      { id:6,name: 'Plataform', icon: 'tags/mushroom.svg' },
      { id:7,name: 'Quiz', icon: 'tags/puzzle.svg' },
      { id:8,name: 'Shooter', icon: 'tags/shooting.svg' },
      { id:9,name: 'Ability', icon: 'tags/golf.svg' }
  ],
  games: [
    {
      name: 'Furious Red Riding Hood',
      path: 'https://assets.gamega.me/cn/fndxhm/index.html',
      icon: 'https://assets.gamega.me/cn/fndxhm/sqricon.jpg',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 19,
      score: 3.736842105263158,
      id: 1
    } ,
    {
      name: 'Striker',
      path: 'https://assets.gamega.me/cn/djz/index.html',
      icon: 'https://assets.gamega.me/cn/djz/sqricon.png',
      tags: [ 'Shooter', 'Maximum score' ],
      votes: 34,
      score: 4.029411764705882,
      id: 2
    } ,
    {
      name: 'Pet Rescue',
      path: 'https://assets.gamega.me/cn/cwdyj/index.html',
      icon: 'https://assets.gamega.me/cn/cwdyj/sqricon.png',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 23,
      score: 4.043478260869565,
      id: 3
    } ,
    {
      name: 'Candy Land',
      path: 'https://assets.gamega.me/cn/tangguo/index.html',
      icon: 'https://assets.gamega.me/cn/tangguo/sqricon.jpg',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 34,
      score: 2.8529411764705883,
      id: 4
    } ,
    {
      name: 'Horse Jump',
      path: 'https://assets.gamega.me/cn/horsegame/index.html',
      icon: 'https://assets.gamega.me/cn/horsegame/sqricon.jpg',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 35,
      score: 3.2857142857142856,
      id: 5
    } ,
    {
      name: 'Monster Union',
      path: 'https://assets.gamega.me/cn/monstersunion/index.html',
      icon: 'https://assets.gamega.me/cn/monstersunion/sqricon.png',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 4,
      score: 3,
      id: 6
    } ,
    {
      name: 'Biggest Brain',
      path: 'https://assets.gamega.me/cn/zqdn/index.html',
      icon: 'https://assets.gamega.me/cn/zqdn/sqricon.png',
      tags: [ 'Maximum score', 'Action', 'Plataform' ],
      votes: 31,
      score: 2.870967741935484,
      id: 7
    } ,
    {
      name: 'Rotating Hexagon',
      path: 'https://assets.gamega.me/cn/znm/index.html',
      icon: 'https://assets.gamega.me/cn/znm/sqricon.png',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 45,
      score: 4.022222222222222,
      id: 8
    } ,
    {
      name: 'Star Motor',
      path: 'https://assets.gamega.me/cn/xjmt/index.html',
      icon: 'https://assets.gamega.me/cn/xjmt/sqricon.png',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 14,
      score: 3.5,
      id: 9
    } ,
    {
      name: 'Crazy Flight',
      path: 'https://assets.gamega.me/cn/ttxdszm/index.html',
      icon: 'https://assets.gamega.me/cn/ttxdszm/sqricon.png',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 47,
      score: 3.723404255319149,
      id: 10
    } ,
    {
      name: 'Candy Love Match',
      path: 'https://assets.gamega.me/cn/ai/index.html',
      icon: 'https://assets.gamega.me/cn/ai/sqricon.png',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 4,
      score: 3.5,
      id: 11
    } ,
    {
      name: 'Circus Troup',
      path: 'https://assets.gamega.me/cn/circus/index.html',
      icon: 'https://assets.gamega.me/cn/circus/sqricon.png',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 44,
      score: 2.909090909090909,
      id: 12
    } ,
    {
      name: 'Game Of SubstrAction',
      path: 'https://assets.gamega.me/cn/szcg/index.html',
      icon: 'https://assets.gamega.me/cn/szcg/sqricon.png',
      tags: [ 'Maximum score', 'Action', 'Plataform' ],
      votes: 42,
      score: 3.8095238095238093,
      id: 13
    } ,
    {
      name: 'Weirdo Link-Link',
      path: 'https://assets.gamega.me/cn/qbllk/index.html',
      icon: 'https://assets.gamega.me/cn/qbllk/sqricon.png',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 27,
      score: 3.740740740740741,
      id: 14
    } ,
    {
      name: 'Room Escape',
      path: 'https://assets.gamega.me/cn/mishi/index.html',
      icon: 'https://assets.gamega.me/cn/mishi/sqricon.png',
      tags: [ 'Plataform', 'Action', 'Ability' ],
      votes: 31,
      score: 3.3870967741935485,
      id: 15
    } ,
    {
      name: 'United Rope',
      path: 'https://assets.gamega.me/cn/jksz/index.html',
      icon: 'https://assets.gamega.me/cn/jksz/sqricon.jpg',
      tags: [ 'Maximum score', 'Action', 'Plataform' ],
      votes: 7,
      score: 3.4285714285714284,
      id: 16
    } ,
    {
      name: 'Golf Garden',
      path: 'https://assets.gamega.me/cn/grfhy/index.html',
      icon: 'https://assets.gamega.me/cn/grfhy/sqricon.png',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 10,
      score: 4.3,
      id: 17
    } ,
    {
      name: 'Mr Crab & his Bubble Fish',
      path: 'https://assets.gamega.me/cn/Bubblefish/index.html',
      icon: 'https://assets.gamega.me/cn/Bubblefish/sqricon.jpg',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 40,
      score: 3.75,
      id: 18
    } ,
    {
      name: 'Blocks Combine',
      path: 'https://assets.gamega.me/cn/blockgame/index.html',
      icon: 'https://assets.gamega.me/cn/blockgame/sqricon.png',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 16,
      score: 4.25,
      id: 19
    } ,
    {
      name: 'Brave Jump',
      path: 'https://assets.gamega.me/cn/100c/index.html',
      icon: 'https://assets.gamega.me/cn/100c/sqricon.png',
      tags: [ 'Plataform', 'Action', 'Ability' ],
      votes: 47,
      score: 4.042553191489362,
      id: 20
    } ,
    {
      name: 'Turn Words',
      path: 'https://assets.gamega.me/cn/zpfff/index.html',
      icon: 'https://assets.gamega.me/cn/zpfff/sqricon.png',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 38,
      score: 3.763157894736842,
      id: 21
    } ,
    {
      name: 'Mosquitoes War',
      path: 'https://assets.gamega.me/cn/wzdz/index.html',
      icon: 'https://assets.gamega.me/cn/wzdz/sqricon.png',
      tags: [ 'Shooter', 'Maximum score' ],
      votes: 41,
      score: 3.7804878048780486,
      id: 22
    } ,
    {
      name: 'Blind Guess',
      path: 'https://assets.gamega.me/cn/dtsl/index.html',
      icon: 'https://assets.gamega.me/cn/dtsl/sqricon.png',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 41,
      score: 2.926829268292683,
      id: 23
    } ,
    {
      name: 'Draw Circle',
      path: 'https://assets.gamega.me/cn/hgy/index.html',
      icon: 'https://assets.gamega.me/cn/hgy/sqricon.png',
      tags: [ 'Maximum score', 'Action', 'Plataform' ],
      votes: 13,
      score: 3.4615384615384617,
      id: 24
    } ,
    {
      name: 'Swing',
      path: 'https://assets.gamega.me/cn/mingxuanyixian/index.html',
      icon: 'https://assets.gamega.me/cn/mingxuanyixian/sqricon.jpg',
      tags: [ 'Plataform', 'Action', 'Ability' ],
      votes: 45,
      score: 2.8666666666666667,
      id: 25
    } ,
    {
      name: 'Search Treasure',
      path: 'https://assets.gamega.me/cn/searchTreasure/index.html',
      icon: 'https://assets.gamega.me/cn/searchTreasure/sqricon.png',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 33,
      score: 3.8181818181818183,
      id: 26
    } ,
    {
      name: 'Roll Bear',
      path: 'https://assets.gamega.me/cn/bear/index.html',
      icon: 'https://assets.gamega.me/cn/bear/sqricon.png',
      tags: [ 'Plataform', 'Action', 'Ability' ],
      votes: 34,
      score: 4.029411764705882,
      id: 27
    } ,
    {
      name: 'Long Legs',
      path: 'https://assets.gamega.me/cn/dct/index.html',
      icon: 'https://assets.gamega.me/cn/dct/sqricon.png',
      tags: [ 'Maximum score', 'Action', 'Plataform' ],
      votes: 30,
      score: 2.933333333333333,
      id: 28
    } ,
    {
      name: 'Happy Fruit',
      path: 'https://assets.gamega.me/cn/fruit/index.html',
      icon: 'https://assets.gamega.me/cn/fruit/sqricon.png',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 35,
      score: 2.8285714285714287,
      id: 29
    } ,
    {
      name: 'Where is Baby',
      path: 'https://assets.gamega.me/cn/mwzne/index.html',
      icon: 'https://assets.gamega.me/cn/mwzne/sqricon.jpg',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 36,
      score: 2.8333333333333335,
      id: 30
    } ,
    {
      name: 'Bullet Attack',
      path: 'https://assets.gamega.me/cn/bulletAttack/index.html',
      icon: 'https://assets.gamega.me/cn/bulletAttack/sqricon.png',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 12,
      score: 4.083333333333333,
      id: 31
    } ,
    {
      name: 'Monster Castle',
      path: 'https://assets.gamega.me/cn/demoncastle/index.html',
      icon: 'https://assets.gamega.me/cn/demoncastle/sqricon.png',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 5,
      score: 4.8,
      id: 32
    } ,
    {
      name: 'Gold Viking',
      path: 'https://assets.gamega.me/cn/goldviking/index.html',
      icon: 'https://assets.gamega.me/cn/goldviking/sqricon.jpg',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 33,
      score: 3.8181818181818183,
      id: 33
    } ,
    {
      name: 'My Building',
      path: 'https://assets.gamega.me/cn/mybuilding/index.html',
      icon: 'https://assets.gamega.me/cn/mybuilding/sqricon.jpg',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 29,
      score: 4.172413793103448,
      id: 34
    } ,
    {
      name: 'Happy Christmas',
      path: 'https://assets.gamega.me/cn/HappyChristmas/index.html',
      icon: 'https://assets.gamega.me/cn/HappyChristmas/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 33,
      score: 4,
      id: 35
    } ,
    {
      name: 'Survive everyone',
      path: 'https://assets.gamega.me/cn/bunengsi/index.html',
      icon: 'https://assets.gamega.me/cn/bunengsi/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 1,
      score: 1,
      id: 36
    } ,
    {
      name: 'Micro-win',
      path: 'https://assets.gamega.me/cn/llll/index.htm',
      icon: 'https://assets.gamega.me/cn/llll/sqricon.jpg',
      tags: [ 'Shooter', 'Maximum score' ],
      votes: 3,
      score: 4.666666666666667,
      id: 37
    } ,
    {
      name: 'Best Egesight',
      path: 'https://assets.gamega.me/cn/zuiqiangyanli/index.htm',
      icon: 'https://assets.gamega.me/cn/zuiqiangyanli/sqricon.jpg',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 1,
      score: 5,
      id: 38
    } ,
    {
      name: 'Shoot Stars',
      path: 'https://assets.gamega.me/cn/ShootStars/index.html',
      icon: 'https://assets.gamega.me/cn/ShootStars/sqricon.png',
      tags: [ 'Shooter', 'Maximum score' ],
      votes: 47,
      score: 3.276595744680851,
      id: 39
    } ,
    {
      name: 'Octopus Hand-in-Hand',
      path: 'https://assets.gamega.me/cn/bzylls/index.html',
      icon: 'https://assets.gamega.me/cn/bzylls/sqricon.jpg',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 14,
      score: 2.7142857142857144,
      id: 40
    } ,
    {
      name: 'Super Mariano',
      path: 'https://assets.gamega.me/cn/cjmla/index.html',
      icon: 'https://assets.gamega.me/cn/cjmla/sqricon.png',
      tags: [ 'Plataform', 'Action', 'Ability' ],
      votes: 13,
      score: 3.3076923076923075,
      id: 41
    } ,
    {
      name: 'Dodge Ship',
      path: 'https://assets.gamega.me/cn/dodgeShip/index.html',
      icon: 'https://assets.gamega.me/cn/dodgeShip/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 36,
      score: 3.6944444444444446,
      id: 42
    } ,
    {
      name: 'Flat Out',
      path: 'https://assets.gamega.me/cn/hczz/index.html',
      icon: 'https://assets.gamega.me/cn/hczz/sqricon.jpg',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 44,
      score: 3.272727272727273,
      id: 43
    } ,
    {
      name: 'Roco Kingdom',
      path: 'https://assets.gamega.me/cn/luoke/index.html',
      icon: 'https://assets.gamega.me/cn/luoke/sqricon.jpg',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 16,
      score: 2.8125,
      id: 44
    } ,
    {
      name: 'Rolling Soccer',
      path: 'https://assets.gamega.me/cn/rollingsoccer/index.html',
      icon: 'https://assets.gamega.me/cn/rollingsoccer/sqricon.jpg',
      tags: [ 'Plataform', 'Action', 'Ability' ],
      votes: 35,
      score: 3.2857142857142856,
      id: 45
    } ,
    {
      name: 'Tap-Tap',
      path: 'https://assets.gamega.me/cn/taptap/index.html',
      icon: 'https://assets.gamega.me/cn/taptap/sqricon.png',
      tags: [ 'Maximum score', 'Action', 'Plataform' ],
      votes: 5,
      score: 3.4,
      id: 46
    } ,
    {
      name: 'Matching Game',
      path: 'https://assets.gamega.me/h5game/MatchingGame/index.html',
      icon: 'https://assets.gamega.me/h5game/MatchingGame/sqricon.png',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 33,
      score: 2.909090909090909,
      id: 47
    } ,
    {
      name: 'Maya',
      path: 'https://assets.gamega.me/h5game/Maya/index.html',
      icon: 'https://assets.gamega.me/h5game/Maya/sqricon.jpg',
      tags: [ 'Shooter', 'Ability' ],
      votes: 41,
      score: 2.926829268292683,
      id: 48
    } ,
    {
      name: 'Medieval Defense Z',
      path: 'https://assets.gamega.me/h5game/MedievalDefenseZ/index.html',
      icon: 'https://assets.gamega.me/h5game/MedievalDefenseZ/sqricon.jpg',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 42,
      score: 3.8095238095238093,
      id: 49
    } ,
    {
      name: 'Meet Kitty',
      path: 'https://assets.gamega.me/h5game/MeetKitty/index.html',
      icon: 'https://assets.gamega.me/h5game/MeetKitty/sqricon.jpg',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 30,
      score: 4.2,
      id: 50
    } ,
    {
      name: 'Merge 13',
      path: 'https://assets.gamega.me/h5game/Merge13/index.html',
      icon: 'https://assets.gamega.me/h5game/Merge13/sqricon.jpg',
      tags: [ 'Quiz', 'Maximum score', 'Plataform' ],
      votes: 13,
      score: 2.6923076923076925,
      id: 51
    } ,
    {
      name: 'Metal Animal',
      path: 'https://assets.gamega.me/h5game/MetalAnimal/index.html',
      icon: 'https://assets.gamega.me/h5game/MetalAnimal/sqricon.jpg',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 42,
      score: 3.8095238095238093,
      id: 52
    } ,
    {
      name: 'Missile Mania',
      path: 'https://assets.gamega.me/h5game/MissileMania/index.html',
      icon: 'https://assets.gamega.me/h5game/MissileMania/icon.jpg',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 18,
      score: 3.6666666666666665,
      id: 53
    } ,
    {
      name: 'Money Moves',
      path: 'https://assets.gamega.me/h5game/MoneyMoves/index.html',
      icon: 'https://assets.gamega.me/h5game/MoneyMoves/icon.jpg',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 46,
      score: 3.282608695652174,
      id: 54
    } ,
    {
      name: 'Monster Cafe',
      path: 'https://assets.gamega.me/h5game/MonsterCafe/index.html',
      icon: 'https://assets.gamega.me/h5game/MonsterCafe/assets/game/icon_heart.png',
      tags: [ 'Shooter', 'Maximum score' ],
      votes: 19,
      score: 2.9473684210526314,
      id: 55
    } ,
    {
      name: 'Monster Mirror Final',
      path: 'https://assets.gamega.me/h5game/MonsterMirrorFinal/index.html',
      icon: 'https://assets.gamega.me/h5game/MonsterMirrorFinal/icon.jpg',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 4,
      score: 2.5,
      id: 56
    } ,
    {
      name: 'Monster Tower Defense',
      path: 'https://assets.gamega.me/h5game/MonsterRushTowerDefense/index.html',
      icon: 'https://assets.gamega.me/h5game/MonsterRushTowerDefense/icon.jpg',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 14,
      score: 3.2857142857142856,
      id: 57
    } ,
    {
      name: 'Monster Truck',
      path: 'https://assets.gamega.me/h5game/MonsterTruck/index.html',
      icon: 'https://assets.gamega.me/h5game/MonsterTruck/icon.png',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 45,
      score: 3.7555555555555555,
      id: 58
    } ,
    {
      name: 'Moopzz',
      path: 'https://assets.gamega.me/h5game/Moopzz/index.html',
      icon: 'https://assets.gamega.me/h5game/Moopzz/icon.png',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 49,
      score: 4.081632653061225,
      id: 59
    } ,
    {
      name: 'Mr Miner',
      path: 'https://assets.gamega.me/h5game/MrMiner/index.html',
      icon: 'https://assets.gamega.me/h5game/MrMiner/icon.png',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 29,
      score: 2.896551724137931,
      id: 60
    } ,
    {
      name: 'MusicLine',
      path: 'https://assets.gamega.me/h5game/MusicLine/index.html',
      icon: 'https://assets.gamega.me/h5game/MusicLine/icon-256.png',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 25,
      score: 3.28,
      id: 61
    } ,
    {
      name: 'My Knight And Me',
      path: 'https://assets.gamega.me/h5game/MyKnightAndMe/index.html',
      icon: 'https://assets.gamega.me/h5game/MyKnightAndMe/icon.png',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 29,
      score: 2.896551724137931,
      id: 62
    } ,
    {
      name: 'My Puppy Play Day',
      path: 'https://assets.gamega.me/h5game/MyPuppyPlayDay/index.html',
      icon: 'https://assets.gamega.me/h5game/MyPuppyPlayDay/icon.png',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 32,
      score: 3.84375,
      id: 63
    } ,
    {
      name: 'Mystic Mahjong Adventures',
      path: 'https://assets.gamega.me/h5game/MysticMahjongAdventures/index.html',
      icon: 'https://assets.gamega.me/h5game/MysticMahjongAdventures/icon.jpg',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 27,
      score: 4.148148148148148,
      id: 64
    } ,
    {
      name: 'Neon Man',
      path: 'https://assets.gamega.me/h5game/NeonMan/index.html',
      icon: 'https://assets.gamega.me/h5game/NeonMan/icon.png',
      tags: [ 'Shooter', 'Maximum score' ],
      votes: 32,
      score: 4.09375,
      id: 65
    } ,
    {
      name: 'New Snake',
      path: 'https://assets.gamega.me/h5game/NewSnake/index.html',
      icon: 'https://assets.gamega.me/h5game/NewSnake/loading-logo.png',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 5,
      score: 3.4,
      id: 66
    } ,
    {
      name: 'Nick Basketball Stars 2',
      path: 'https://assets.gamega.me/h5game/NickBasketballStars2/index.html',
      icon: 'https://assets.gamega.me/h5game/NickBasketballStars2/icon.png',
      tags: [ 'Plataform', 'Action', 'Ability' ],
      votes: 29,
      score: 3.2758620689655173,
      id: 67
    } ,
    {
      name: 'Night Runner',
      path: 'https://assets.gamega.me/h5game/NightRunner/index.html',
      icon: 'https://assets.gamega.me/h5game/NightRunner/icon.png',
      tags: [ 'Maximum score', 'Action', 'Plataform' ],
      votes: 28,
      score: 4.142857142857143,
      id: 68
    } ,
    {
      name: 'Quit Smoking',
      path: 'https://assets.gamega.me/h5game/QuitSmoking/index.html',
      icon: 'https://assets.gamega.me/h5game/QuitSmoking/icon.png',
      tags: [ 'Plataform', 'Action', 'Ability' ],
      votes: 29,
      score: 3.2758620689655173,
      id: 69
    } ,
    {
      name: 'Random Runner',
      path: 'https://assets.gamega.me/h5game/RandomRunner/index.html',
      icon: 'https://assets.gamega.me/h5game/RandomRunner/icon.jpg',
      tags: [ 'Maximum score', 'Action', 'Plataform' ],
      votes: 10,
      score: 3.9,
      id: 70
    } ,
    {
      name: 'Rayi Fox',
      path: 'https://assets.gamega.me/h5game/RayiFox/index.html',
      icon: 'https://assets.gamega.me/h5game/RayiFox/icon-256.png',
      tags: [ 'Plataform', 'Action', 'Ability' ],
      votes: 41,
      score: 3.7804878048780486,
      id: 71
    } ,
    {
      name: 'Real Tennis3d',
      path: 'https://assets.gamega.me/h5game/RealTennis3d/index.html',
      icon: 'https://assets.gamega.me/h5game/RealTennis3d/icon.jpg',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 14,
      score: 3.5,
      id: 72
    } ,
    {
      name: 'RedRiding Hood Run',
      path: 'https://assets.gamega.me/h5game/RedRidingHoodRun/index.html',
      icon: 'https://assets.gamega.me/h5game/RedRidingHoodRun/icon.png',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 1,
      score: 1,
      id: 73
    } ,
    {
      name: 'Reflector',
      path: 'https://assets.gamega.me/h5game/Reflector/index.html',
      icon: 'https://assets.gamega.me/h5game/Reflector/icon.jpg',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 5,
      score: 4.8,
      id: 74
    } ,
    {
      name: 'Risky Mission',
      path: 'https://assets.gamega.me/h5game/RiskyMission/index.html',
      icon: 'https://assets.gamega.me/h5game/RiskyMission/icon.jpg',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 11,
      score: 4,
      id: 75
    } ,
    {
      name: 'Road Kill',
      path: 'https://assets.gamega.me/h5game/RoadKill/index.html',
      icon: 'https://assets.gamega.me/h5game/RoadKill/icon-256.png',
      tags: [ 'Maximum score', 'Action', 'Plataform' ],
      votes: 10,
      score: 2.7,
      id: 76
    } ,
    {
      name: 'Road Racer',
      path: 'https://assets.gamega.me/h5game/RoadRacer/index.html',
      icon: 'https://assets.gamega.me/h5game/RoadRacer/icon.jpg',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 37,
      score: 4.081081081081081,
      id: 77
    } ,
    {
      name: 'RoboBattle',
      path: 'https://assets.gamega.me/h5game/RoboBattle/index.html',
      icon: 'https://assets.gamega.me/h5game/RoboBattle/icon.png',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 39,
      score: 2.8974358974358974,
      id: 78
    } ,
    {
      name: 'Robo Twins',
      path: 'https://assets.gamega.me/h5game/RoboTwins/index.html',
      icon: 'https://assets.gamega.me/h5game/RoboTwins/icon-256.png',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 36,
      score: 3.6944444444444446,
      id: 79
    } ,
    {
      name: 'Rogue One',
      path: 'https://assets.gamega.me/h5game/RogueOneBootsOnTheGround/index.html',
      icon: 'https://assets.gamega.me/h5game/RogueOneBootsOnTheGround/icon.jpg',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 18,
      score: 2.888888888888889,
      id: 80
    } ,
    {
      name: 'Rope Ninja',
      path: 'https://assets.gamega.me/h5game/RopeNinja/index.html',
      icon: 'https://assets.gamega.me/h5game/RopeNinja/icon.png',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 15,
      score: 3.3333333333333335,
      id: 81
    } ,
    {
      name: 'Royal Knight',
      path: 'https://assets.gamega.me/h5game/RoyalKnight/index.html',
      icon: 'https://assets.gamega.me/h5game/RoyalKnight/spartan.jpg',
      tags: [ 'Maximum score', 'Action', 'Plataform' ],
      votes: 41,
      score: 4.146341463414634,
      id: 82
    } ,
    {
      name: 'Runner',
      path: 'https://assets.gamega.me/h5game/Runner/index.html',
      icon: 'https://assets.gamega.me/h5game/Runner/icon.png',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 43,
      score: 4.069767441860465,
      id: 83
    } ,
    {
      name: 'Sagemath',
      path: 'https://assets.gamega.me/h5game/Sagemath/index.html',
      icon: 'https://assets.gamega.me/h5game/Sagemath/icon.png',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 47,
      score: 3.276595744680851,
      id: 84
    } ,
    {
      name: 'Super Plumber',
      path: 'https://assets.gamega.me/h5game/SuperPlumber/index.html',
      icon: 'https://assets.gamega.me/h5game/SuperPlumber/icon.jpg',
      tags: [ 'Shooter', 'Maximum score' ],
      votes: 43,
      score: 3.8372093023255816,
      id: 85
    } ,
    {
      name: 'Super Scary Stacker',
      path: 'https://assets.gamega.me/h5game/SuperScaryStacker/index.html',
      icon: 'https://assets.gamega.me/h5game/SuperScaryStacker/icon.png',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 21,
      score: 3.857142857142857,
      id: 86
    } ,
    {
      name: 'Sweet Garden',
      path: 'https://assets.gamega.me/h5game/SweetGarden/index.html',
      icon: 'https://assets.gamega.me/h5game/SweetGarden/icon.png',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 40,
      score: 3.275,
      id: 87
    } ,
    {
      name: 'Sweet Jelly',
      path: 'https://assets.gamega.me/h5game/SweetJelly/index.html',
      icon: 'https://assets.gamega.me/h5game/SweetJelly/icon.jpg',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 48,
      score: 3.2916666666666665,
      id: 88
    } ,
    {
      name: 'Swipe Art Puzzle',
      path: 'https://assets.gamega.me/h5game/SwipeArtPuzzle/index.html',
      icon: 'https://assets.gamega.me/h5game/SwipeArtPuzzle/icon.png',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 19,
      score: 4.315789473684211,
      id: 89
    } ,
    {
      name: 'Swipex',
      path: 'https://assets.gamega.me/h5game/Swipex/index.html',
      icon: 'https://assets.gamega.me/h5game/Swipex/icon.png',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 32,
      score: 3.3125,
      id: 90
    } ,
    {
      name: 'Swooop',
      path: 'https://assets.gamega.me/h5game/Swooop/index.html',
      icon: 'https://assets.gamega.me/h5game/Swooop/icon.png',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 46,
      score: 2.847826086956522,
      id: 91
    } ,
    {
      name: 'Table Tennis World Tour',
      path: 'https://assets.gamega.me/h5game/TableTennisWorldTour/index.html',
      icon: 'https://assets.gamega.me/h5game/TableTennisWorldTour/tenis.png',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 28,
      score: 3.7142857142857144,
      id: 92
    } ,
    {
      name: 'Tacit',
      path: 'https://assets.gamega.me/h5game/Tacit/index.html',
      icon: 'https://assets.gamega.me/h5game/Tacit/assets/button_black.png',
      tags: [ 'Guess', 'Maximum score' ],
      votes: 35,
      score: 3.6857142857142855,
      id: 93
    } ,
    {
      name: 'Tank Defender',
      path: 'https://assets.gamega.me/h5game/TankDefender/index.html',
      icon: 'https://assets.gamega.me/h5game/TankDefender/icon-256.png',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 47,
      score: 4.042553191489362,
      id: 94
    } ,
    {
      name: 'Teddies Defender',
      path: 'https://assets.gamega.me/h5game/TeddiesDefender/index.html',
      icon: 'https://assets.gamega.me/h5game/TeddiesDefender/icon.png',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 6,
      score: 3.5,
      id: 95
    } ,
    {
      name: 'Teenage Turtles PizzaQuest',
      path: 'https://assets.gamega.me/h5game/TeenageMutantNinjaTurtlesPizzaQuest/index.html',
      icon: 'https://assets.gamega.me/h5game/TeenageMutantNinjaTurtlesPizzaQuest/icon.png',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 19,
      score: 3.3684210526315788,
      id: 96
    } ,
    {
      name: 'TheLast Survivors',
      path: 'https://assets.gamega.me/h5game/TheLastSurvivors/index.html',
      icon: 'https://assets.gamega.me/h5game/TheLastSurvivors/icon.png',
      tags: [ 'Ability', 'Action', 'Shooter' ],
      votes: 15,
      score: 2.8,
      id: 97
    } ,
    {
      name: 'TheLost Planet Tower Defense',
      path: 'https://assets.gamega.me/h5game/TheLostPlanetTowerDefense/index.html',
      icon: 'https://assets.gamega.me/h5game/TheLostPlanetTowerDefense/icon.png',
      tags: [ 'Quiz', 'Adventure', 'Plataform' ],
      votes: 5,
      score: 3.4,
      id: 98
    } ,
    {
      name: 'The Planetarium',
      path: 'https://assets.gamega.me/h5game/ThePlanetarium/index.html',
      icon: 'https://assets.gamega.me/h5game/ThePlanetarium/img/earth.jpg',
      tags: [ 'Adventure', 'Plataform' ],
      votes: 36,
      score: 2.8333333333333335,
      id: 99
    } ,
    {
      name: 'Farm Frenzy 2',
      path: 'https://assets.gamega.me/p2m/farm-frenzy-2/index.html',
      icon: 'https://assets.gamega.me/p2m/farm-frenzy-2/icon_farm_frenzy_2.jpg',
      tags: [ 'Plataform', 'Ability', 'Adventure', 'Maximum score' ],
      votes: 15,
      score: 4.2,
      id: 100
    } ,
    {
      name: 'Treasures of Montezuma 2',
      path: 'https://assets.gamega.me/p2m/treasures-of-montezuma-2/index.html',
      icon: 'https://assets.gamega.me/p2m/treasures-of-montezuma-2/sqricon.jpg',
      tags: [ 'Ability', 'Plataform', 'Adventure', 'Maximum score' ],
      votes: 5,
      score: 3.4,
      id: 101
    } ,
    {
      name: 'Bullet Attack',
      path: 'https://assets.gamega.me/p2m/bulletAttack/index.html',
      icon: 'https://assets.gamega.me/p2m/bulletAttack/icon_bulletattack.jpg',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 14,
      score: 2.7142857142857144,
      id: 102
    } ,
    {
      name: "I'm a Thief",
      path: 'https://assets.gamega.me/avi/1111122/index.html',
      icon: 'https://assets.gamega.me/avi/1111122/sqricon.png',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 37,
      score: 4.081081081081081,
      id: 103
    } ,
    {
      name: 'Fighting for Love',
      path: 'https://assets.gamega.me/avi/146424630114558/index.html',
      icon: 'https://assets.gamega.me/avi/146424630114558/sqricon.png',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 49,
      score: 3.7755102040816326,
      id: 104
    } ,
    {
      name: 'Black Jack',
      path: 'https://assets.gamega.me/avi/BlackJackgamekeyfixed/index.html',
      icon: 'https://assets.gamega.me/avi/BlackJackgamekeyfixed/sqricon.png',
      tags: [ 'Ability', 'Quiz', 'Maximum score' ],
      votes: 1,
      score: 1,
      id: 105
    } ,
    {
      name: 'Dark Forest',
      path: 'https://assets.gamega.me/avi/dark_0203/index.html',
      icon: 'https://assets.gamega.me/avi/dark_0203/sqricon.png',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 22,
      score: 3.272727272727273,
      id: 106
    } ,
    {
      name: 'Hidden Objects: Pirate Adventures',
      path: 'https://assets.gamega.me/avi/HiddenObjectsPirateAdventures201601122/index.html',
      icon: 'https://assets.gamega.me/avi/HiddenObjectsPirateAdventures201601122/sqricon.png',
      tags: [ 'Ability', 'Quiz', 'Maximum score' ],
      votes: 7,
      score: 3.4285714285714284,
      id: 107
    } ,
    {
      name: 'Slot Machine: 777',
      path: 'https://assets.gamega.me/avi/labazhengshifu/index.html',
      icon: 'https://assets.gamega.me/avi/labazhengshifu/sqricon.png',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 43,
      score: 4.069767441860465,
      id: 108
    } ,
    {
      name: 'Miner Block',
      path: 'https://assets.gamega.me/avi/Minerblock_0229/index.html',
      icon: 'https://assets.gamega.me/avi/Minerblock_0229/sqricon.png',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 6,
      score: 4.666666666666667,
      id: 109
    } ,
    {
      name: 'Net',
      path: 'https://assets.gamega.me/avi/net_em_1215/index.html',
      icon: 'https://assets.gamega.me/avi/net_em_1215/sqricon.png',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 14,
      score: 3.2857142857142856,
      id: 110
    } ,
    {
      name: 'Speed Pool King',
      path: 'https://assets.gamega.me/avi/SpeedPoolKing_0304/index.html',
      icon: 'https://assets.gamega.me/avi/SpeedPoolKing_0304/sqricon.png',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 29,
      score: 3.7241379310344827,
      id: 111
    } ,
    {
      name: 'Spider Solitaire',
      path: 'https://assets.gamega.me/avi/spider_solitaire_0202/index.html',
      icon: 'https://assets.gamega.me/avi/spider_solitaire_0202/sqricon.png',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 8,
      score: 3.5,
      id: 112
    } ,
    {
      name: 'Ten Basket',
      path: 'https://assets.gamega.me/avi/TenBasket_0308/index.html',
      icon: 'https://assets.gamega.me/avi/TenBasket_0308/sqricon.png',
      tags: [ 'Ability', 'Shooter', 'Maximum score' ],
      votes: 5,
      score: 3.4,
      id: 113
    } ,
    {
      name: 'Do not DIE!',
      path: 'https://assets.gamega.me/cn2/DO NOT DIE/index.html',
      icon: 'https://assets.gamega.me/cn2/DO NOT DIE/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 46,
      score: 3.717391304347826,
      id: 114
    } ,
    {
      name: 'Poke the Bubble',
      path: 'https://assets.gamega.me/cn2/cpp/index.html',
      icon: 'https://assets.gamega.me/cn2/cpp/sqricon.png',
      tags: [ 'Ability', 'Action', 'Maximum score', 'Shooter' ],
      votes: 42,
      score: 3.8095238095238093,
      id: 115
    } ,
    {
      name: 'Defence of Karmax 3',
      path: 'https://assets.gamega.me/cn2/fangyuzjz/index.html',
      icon: 'https://assets.gamega.me/cn2/fangyuzjz/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 10,
      score: 3.9,
      id: 116
    } ,
    {
      name: 'Top Farm',
      path: 'https://assets.gamega.me/cn2/farm/index.html',
      icon: 'https://assets.gamega.me/cn2/farm/sqricon.jpg',
      tags: [ 'Kids', 'Adventure', 'Maximum score' ],
      votes: 7,
      score: 3.4285714285714284,
      id: 117
    } ,
    {
      name: 'Find a way out',
      path: 'https://assets.gamega.me/cn2/Find away out/index.html',
      icon: 'https://assets.gamega.me/cn2/Find away out/sqricon.jpg',
      tags: [ 'Guess', 'Adventure', 'Quiz' ],
      votes: 35,
      score: 2.8285714285714287,
      id: 118
    } ,
    {
      name: 'Flip and Find',
      path: 'https://assets.gamega.me/cn2/Flip and Find/index.html',
      icon: 'https://assets.gamega.me/cn2/Flip and Find/sqricon.jpg',
      tags: [ 'Guess', 'Quiz', 'Maximum score' ],
      votes: 30,
      score: 4.2,
      id: 119
    } ,
    {
      name: 'Forest Knight',
      path: 'https://assets.gamega.me/cn2/Forest Knight/index.html',
      icon: 'https://assets.gamega.me/cn2/Forest Knight/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 9,
      score: 3.6666666666666665,
      id: 120
    } ,
    {
      name: 'Fix 2048',
      path: 'https://assets.gamega.me/cn2/gd2048/index.html',
      icon: 'https://assets.gamega.me/cn2/gd2048/sqricon.jpg',
      tags: [ 'Guess', 'Quiz', 'Maximum score' ],
      votes: 20,
      score: 3.45,
      id: 121
    } ,
    {
      name: 'Grab the rope',
      path: 'https://assets.gamega.me/cn2/Grab the rope/index.html',
      icon: 'https://assets.gamega.me/cn2/Grab the rope/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 25,
      score: 4.08,
      id: 122
    } ,
    {
      name: 'Hand in Hand',
      path: 'https://assets.gamega.me/cn2/hand in hand/index.html',
      icon: 'https://assets.gamega.me/cn2/hand in hand/sqricon.jpg',
      tags: [ 'Guess', 'Quiz', 'Adventure' ],
      votes: 35,
      score: 3.6857142857142855,
      id: 123
    } ,
    {
      name: 'Happy Fishing',
      path: 'https://assets.gamega.me/cn2/Happy Fishing/index.html',
      icon: 'https://assets.gamega.me/cn2/Happy Fishing/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 1,
      score: 1,
      id: 124
    } ,
    {
      name: 'Jump, Jump!',
      path: 'https://assets.gamega.me/cn2/hcrdtw/index.html',
      icon: 'https://assets.gamega.me/cn2/hcrdtw/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 24,
      score: 4.083333333333333,
      id: 125
    } ,
    {
      name: 'DRAGONS!',
      path: 'https://assets.gamega.me/cn2/hl/index.html',
      icon: 'https://assets.gamega.me/cn2/hl/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 10,
      score: 3.4,
      id: 126
    } ,
    {
      name: 'It Takes Two',
      path: 'https://assets.gamega.me/cn2/ItTakes Two/index.html',
      icon: 'https://assets.gamega.me/cn2/It Takes Two/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 12,
      score: 3.5833333333333335,
      id: 127
    } ,
    {
      name: 'Throw Egg',
      path: 'https://assets.gamega.me/cn2/jidan/index.html',
      icon: 'https://assets.gamega.me/cn2/jidan/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 27,
      score: 4.148148148148148,
      id: 128
    } ,
    {
      name: 'Bird Jump',
      path: 'https://assets.gamega.me/cn2/jntt/index.html',
      icon: 'https://assets.gamega.me/cn2/jntt/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 37,
      score: 3.2972972972972974,
      id: 129
    } ,
    {
      name: 'Limit Overtaking',
      path: 'https://assets.gamega.me/cn2/jxcc/index.html',
      icon: 'https://assets.gamega.me/cn2/jxcc/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 33,
      score: 3.8181818181818183,
      id: 130
    } ,
    {
      name: 'Hyper Gunner',
      path: 'https://assets.gamega.me/cn2/ld/index.html',
      icon: 'https://assets.gamega.me/cn2/ld/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score', 'Shooter' ],
      votes: 8,
      score: 3.625,
      id: 131
    } ,
    {
      name: 'Little architect',
      path: 'https://assets.gamega.me/cn2/Little architect/index.html',
      icon: 'https://assets.gamega.me/cn2/Little architect/sqricon.jpg',
      tags: [ 'Guess', 'Kids', 'Maximum score' ],
      votes: 32,
      score: 2.84375,
      id: 132
    } ,
    {
      name: 'Max Area',
      path: 'https://assets.gamega.me/cn2/maxarea/index.html',
      icon: 'https://assets.gamega.me/cn2/maxarea/sqricon.jpg',
      tags: [ 'Guess', 'Quiz', 'Maximum score' ],
      votes: 45,
      score: 2.8666666666666667,
      id: 133
    } ,
    {
      name: 'Maya',
      path: 'https://assets.gamega.me/cn2/maya/index.html',
      icon: 'https://assets.gamega.me/cn2/maya/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score', 'Kids' ],
      votes: 11,
      score: 4,
      id: 134
    } ,
    {
      name: 'Light Bulb',
      path: 'https://assets.gamega.me/cn2/mml/index.html',
      icon: 'https://assets.gamega.me/cn2/mml/sqricon.png',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 11,
      score: 2.909090909090909,
      id: 135
    } ,
    {
      name: 'Monkey',
      path: 'https://assets.gamega.me/cn2/monkey/index.html',
      icon: 'https://assets.gamega.me/cn2/monkey/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 10,
      score: 4.3,
      id: 136
    } ,
    {
      name: 'Motor GO!',
      path: 'https://assets.gamega.me/cn2/MOTOR GO/index.html',
      icon: 'https://assets.gamega.me/cn2/MOTOR GO/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 24,
      score: 4.083333333333333,
      id: 137
    } ,
    {
      name: 'Skyscrapers',
      path: 'https://assets.gamega.me/cn2/mtl/index.html',
      icon: 'https://assets.gamega.me/cn2/mtl/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 46,
      score: 3.282608695652174,
      id: 138
    } ,
    {
      name: 'The balloon BANG!',
      path: 'https://assets.gamega.me/cn2/qqppp/index.html',
      icon: 'https://assets.gamega.me/cn2/qqppp/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 48,
      score: 3.2916666666666665,
      id: 139
    } ,
    {
      name: 'Rhinoceros skating',
      path: 'https://assets.gamega.me/cn2/rhino/index.html',
      icon: 'https://assets.gamega.me/cn2/rhino/icon.png',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 18,
      score: 2.888888888888889,
      id: 140
    } ,
    {
      name: 'Air Media',
      path: 'https://assets.gamega.me/cn2/sqs/index.html',
      icon: 'https://assets.gamega.me/cn2/sqs/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 1,
      score: 5,
      id: 141
    } ,
    {
      name: '3D bears come and go',
      path: 'https://assets.gamega.me/cn2/xiongchumo/index.html',
      icon: 'https://assets.gamega.me/cn2/xiongchumo/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 10,
      score: 3.4,
      id: 142
    } ,
    {
      name: 'To eliminate the stars',
      path: 'https://assets.gamega.me/cn2/xmxx/index.html',
      icon: 'https://assets.gamega.me/cn2/xmxx/sqricon.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 17,
      score: 4.235294117647059,
      id: 143
    } ,
    {
      name: 'Candyzuma',
      path: 'https://assets.gamega.me/p2m/candyzuma/index.html',
      icon: 'https://assets.gamega.me/p2m/candyzuma/icon_candyzuma.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 21,
      score: 3.3333333333333335,
      id: 144
    } ,
    {
      name: 'Circus Troop',
      path: 'https://assets.gamega.me/p2m/circus/index.html',
      icon: 'https://assets.gamega.me/p2m/circus/icon_circus_troop.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 39,
      score: 4.102564102564102,
      id: 145
    } ,
    {
      name: 'Dragon Climb',
      path: 'https://assets.gamega.me/p2m/dragon-climb/index.html',
      icon: 'https://assets.gamega.me/p2m/dragon-climb/icon_dragon_climb.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 33,
      score: 4,
      id: 146
    } ,
    {
      name: 'Farm Alarm',
      path: 'https://assets.gamega.me/p2m/farm-alarm/index.html',
      icon: 'https://assets.gamega.me/p2m/farm-alarm/icon_farm_alarm.jpg',
      tags: [ 'Ability', 'Adventure', 'Maximum score', 'Plataform' ],
      votes: 33,
      score: 3.8181818181818183,
      id: 147
    } ,
    {
      name: 'Flappy Nerd',
      path: 'https://assets.gamega.me/p2m/flappy-nerd/index.html',
      icon: 'https://assets.gamega.me/p2m/flappy-nerd/icon_flappy_nerd.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 45,
      score: 3.2666666666666666,
      id: 148
    } ,
    {
      name: 'Happy Fruit',
      path: 'https://assets.gamega.me/p2m/fruit/index.html',
      icon: 'https://assets.gamega.me/p2m/fruit/icon_happy_fruit.jpg',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 35,
      score: 4.057142857142857,
      id: 149
    } ,
    {
      name: 'Hide Caesar 2',
      path: 'https://assets.gamega.me/p2m/hide-caesar-2/index.html',
      icon: 'https://assets.gamega.me/p2m/hide-caesar-2/icon_hide_caesar.jpg',
      tags: [ 'Quiz', 'Guess', 'Kids' ],
      votes: 6,
      score: 2.8333333333333335,
      id: 150
    } ,
    {
      name: 'Jump Escape',
      path: 'https://assets.gamega.me/p2m/jump-escape/index.html',
      icon: 'https://assets.gamega.me/p2m/jump-escape/icon_jump_escape.jpg',
      tags: [ 'Ability', 'Action', 'Maximum score' ],
      votes: 46,
      score: 4.043478260869565,
      id: 151
    } ,
    {
      name: 'Slider Puzzle',
      path: 'https://assets.gamega.me/p2m/puzzle/index.html',
      icon: 'https://assets.gamega.me/p2m/puzzle/icon_slider_puzzle.jpg',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 26,
      score: 3.6923076923076925,
      id: 152
    } ,
    {
      name: 'Rabbit Launcher',
      path: 'https://assets.gamega.me/p2m/rabbit-launcher/index.html',
      icon: 'https://assets.gamega.me/p2m/rabbit-launcher/icon_rabbitlauncher.jpg',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 41,
      score: 3.317073170731707,
      id: 153
    } ,
    {
      name: 'Fishing Fun',
      path: 'https://assets.gamega.me/cn/hldy/index.html',
      icon: 'https://assets.gamega.me/cn/hldy/sqricon.png',
      tags: [ 'Kids', 'Maximum score' ],
      votes: 9,
      score: 4.555555555555555,
      id: 154
    } ,
    {
      name: 'Jump or Die',
      path: 'https://assets.gamega.me/cn/ssrz/index.html',
      icon: 'https://assets.gamega.me/cn/ssrz/sqricon.jpg',
      tags: [ 'Action', 'Adventure', 'Plataform' ],
      votes: 30,
      score: 3.7666666666666666,
      id: 155
    } ,
    {
      name: 'Save Butterflies',
      path: 'https://assets.gamega.me/p2m/save-butterflies/index.html',
      icon: 'https://assets.gamega.me/p2m/save-butterflies/icon_save_butterflies.jpg',
      tags: [ 'Ability', 'Adventure', 'Maximum score' ],
      votes: 31,
      score: 3.3870967741935485,
      id: 156
    } 
  ]
}

export default {
  state
}


// WEBPACK FOOTER //
// ./src/store/gg/games.js